import { UserAvatarSmall } from '../../../user-avatar/user-avatar-small';
import globalUserProfile from '../../../../stores/global-user-profile';
import React, { useState, useRef } from 'react';
import { UserProfileDialog } from './user-profile-dialog';
import { observer } from 'mobx-react-lite';

export const SideBarUserProfile = observer(() => {
  const [showProfileDialog, setShowProfileDialog] = useState<boolean>(false);
  const isClosingRef = useRef<boolean>(false);

  const handleOpenDialog = (e: React.MouseEvent) => {
    e.stopPropagation();
    // Only open if we're not in the process of closing
    if (!isClosingRef.current && !showProfileDialog) {
      setShowProfileDialog(true);
    }
  };

  const handleCloseDialog = () => {
    isClosingRef.current = true;
    setShowProfileDialog(false);
    // Reset the closing flag after a short delay
    setTimeout(() => {
      isClosingRef.current = false;
    }, 100);
  };

  // Don't render until full profile is loaded
  if (
    !globalUserProfile.isFullProfileLoaded ||
    !globalUserProfile.userProfile?.userWithRole
  ) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '16px 0',
        paddingRight: '16px',
        borderTop: '1px solid var(--surface-200)',
        marginTop: '16px',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease',
      }}
      onClick={handleOpenDialog}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = 'var(--surface-50)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'transparent';
      }}
    >
      <div
        style={{
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          backgroundColor: 'var(--surface-200)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginLeft: '12px',
          overflow: 'hidden',
        }}
      >
        <UserAvatarSmall
          imageUrl={`${globalUserProfile.userProfile?.userWithRole.fileUrl}`}
          firstName={globalUserProfile.userProfile?.userWithRole.firstName}
          lastName={globalUserProfile.userProfile?.userWithRole.lastName}
        />
        {/*            <img
              src={`${globalUserProfile.userProfile?.userWithRole.fileUrl}`}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />*/}
      </div>
      <span style={{ color: 'var(--surface-900)', fontWeight: 500 }}>
        {globalUserProfile.userProfile?.userWithRole.firstName}{' '}
        {globalUserProfile.userProfile?.userWithRole.lastName}
      </span>

      {/* Profile Dialog */}
      <UserProfileDialog
        visible={showProfileDialog}
        onHide={handleCloseDialog}
        user={globalUserProfile.userProfile?.userWithRole}
      />
    </div>
  );
});
